import { z } from 'zod';

export const ACKNOWLEDGEMENT_TYPE = {
  Acknowledgement: 0,
  Document: 1,
} as const;

export type AcknowledgementType = keyof typeof ACKNOWLEDGEMENT_TYPE;

const AcknowledgementSchema = z.object({
  AcknowledgementType: z.string(),
  AcknowledgementId: z.number(),
  AcknowledgementTitle: z.string(),
  AcknowledgementFileName: z.string(),
  Version: z.string().optional(),
  ContentType: z.string(),
  ClientId: z.number(),

  DocumentId: z.string().uuid().optional(),

  CompanyAcknowledgementId: z.string().uuid().optional(),
  Source: z.enum(['document', 'company-acknowledgement']).optional(),
});

export const AcknowledgementsSchema = z.array(AcknowledgementSchema);

export const AcknowledgeResponseSchema = z.object({
  ClientId: z.number().int().optional(),
  AcknowledgementType: z.string().optional(),
  AcknowledgementId: z.number().int().optional(),
  Acknowledged: z.boolean().optional(),
  DocumentId: z.number().int().optional(),
  CompanyAcknowledgementId: z.string().uuid().optional(),
  success: z.boolean().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
});

export const CompanyAcknowledgementResponseSchema = z.object({
  companyAcknowledgementId: z.string().uuid(),
  type: z.string(),
  fileName: z.string(),
  contentType: z.string(),
  version: z.string().optional(),
  validFrom: z.string().optional(),
  validTo: z.string().nullable().optional(),
  status: z.union([z.string(), z.number()]).optional(),
  dateCreated: z.string().optional(),
});

export const CompanyAcknowledgementResponseArraySchema = z.array(CompanyAcknowledgementResponseSchema);

export type Acknowledgement = z.infer<typeof AcknowledgementSchema>;
export type Acknowledgements = z.infer<typeof AcknowledgementsSchema>;
export type AcknowledgeResponse = z.infer<typeof AcknowledgeResponseSchema>;
export type CompanyAcknowledgementResponse = z.infer<typeof CompanyAcknowledgementResponseSchema>;
